<script setup>
import {computed} from 'vue'
import PagePath from '@/common/PagePath.vue'
import Button from '@/common/Button.vue'
import {useModalsStore} from '@/stores/modals'

const props = defineProps({
    field: Object,
    item: Object
})

const modalsStore = useModalsStore()

// Computed: Parse the stored value as an integer for the PagePath component
const pageId = computed(() => {
    return parseInt(props.item.value)
})

// Methods
const openSiteTreeModal = () => {
    modalsStore.show({
        componentName: 'SiteTreeModal',
        obj: {
            pageId: pageId.value,
            // Callback updates the item value directly via the object reference
            onPageSelect: (newPageId) => {
                props.item.value = newPageId
            }
        }
    })
}
</script>

<template>
    <span>
        <Button @click="openSiteTreeModal" class="btn-sm border me-2">
            Browse…
        </Button>
        <PagePath v-if="pageId" :page-id="pageId" class="small"/>
    </span>
</template>